import React from 'react';
import Index from '../components/detailComponent';
import Navbar from '../components/navbar/navbar';

const DetailProduct = () => {
    return (
        <div className='detail'>
            <Navbar/>
            <Index/>
        </div>
    );
}

export default DetailProduct;
